import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions';

type InlineMauiWidthInput = {
	experienceId?: string;
	nodeType?: ExtensionComponentProps['node']['type'];
	width?: number;
};

export const isInlineMauiWidthEligible = ({
	experienceId,
	nodeType,
	width,
}: InlineMauiWidthInput): boolean =>
	nodeType === 'inlineExtension' && experienceId === 'maui' && width === undefined;
